import { render, staticRenderFns } from "./DepositStatusFilter.vue?vue&type=template&id=5bfaf38a"
import script from "./DepositStatusFilter.vue?vue&type=script&lang=js"
export * from "./DepositStatusFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports